module.exports = __webpack_public_path__ + "static/media/seven.ce0ca883.svg";